/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".filter-panel[_ngcontent-%COMP%]{position:relative;justify-items:start;padding:10px;background-color:#f5f5f5}dx-data-grid[_ngcontent-%COMP%]{flex:auto;height:calc(100% - 50px)}"];
export { styles as styles };
